module.exports = __webpack_public_path__ + "img/engagement-party.e2465015.jpeg";